import { UpdateAdvisingHeaderTaskRequest } from './../pages/receiving-instruction/interface/receiving-instruction-header-updaterequest';
import { UpdateAdvisingDetailTaskRequest } from './../pages/receiving-instruction/interface/receiving-instruction-detail-updaterequest';
import { ReceivingInstructionDetailResponse } from './../pages/receiving-instruction/interface/receiving-instruction-detail-response';
import { PageResp } from './../../../core/models/page/page-response';
import { ReceivingInstructionResponse } from './../pages/receiving-instruction/interface/receiving-instruction-response';
import { Observable } from 'rxjs';
import { ReceivingInstructionRequest } from './../pages/receiving-instruction/interface/receiving-instruction-request';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReceivingInstructionDetailRequest } from '../pages/receiving-instruction/interface/receiving-instruction-detail-request';
import { ReceivingInstructionDetailReturnRequest } from '../pages/receiving-instruction/interface/receiving-instruction-detail-return-request';
import { TaskListOptions } from 'src/app/core/models/options/task-list-options';
import { ReceivingInstructionFilesRequest } from '../pages/receiving-instruction/interface/receiving-instruction-file-request';
import { ReceivingInstructionFilesResponse } from '../pages/receiving-instruction/interface/receiving-instruction-file-response';
import { ReceivingInstructionFileUpdateRequest } from '../pages/receiving-instruction/interface/receiving-instruction-file-update-request';
import { ReceivingInstructionFileUpdateResponse } from '../pages/receiving-instruction/interface/receiving-instruction-file-update-response';
import {UpdateReceivingTaskRequest} from '../pages/receiving-instruction/interface/update-receiving-task-request';

@Injectable({
  providedIn: 'root'
})
export class ReceivingInstructionService {

  constructor(private http: HttpClient) { }

  searchReceivingInstruction(request: ReceivingInstructionRequest): Observable<PageResp<ReceivingInstructionResponse>>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/searchHeader`;
    return this.http.post<PageResp<ReceivingInstructionResponse>>(url, request);
  }

  searchReceivingInstructionDetail(request: ReceivingInstructionDetailRequest): Observable<ReceivingInstructionDetailResponse[]>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/searchDetail`;
    return this.http.post<ReceivingInstructionDetailResponse[]>(url, request);
  }

  async searchReceivingInstructionAllDetail(adNo: string): Promise<ReceivingInstructionDetailResponse[] | undefined> {
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/searchAllDetail/${adNo}`;
    return this.http.post<ReceivingInstructionDetailResponse[]>(url, null).toPromise();
  }

  returnReceivingInstructionTask(request: ReceivingInstructionDetailReturnRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/returnReceivingInstructionTask`;
    return this.http.post(url, request);
   }

  async getReceivingInstructionTaskLogic(adTaskType: string): Promise<Map<string, string[]>> {
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/getReceivingInstructionTaskLogic/${adTaskType}`
    return this.http.post<any>(url, null).toPromise();
  }

  getReceivingTaskList(adTaskType: string, language: string): Observable<TaskListOptions[]>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/getTaskList/${adTaskType}/${language}`
    return this.http.get<TaskListOptions[]>(url);
  }

  updateDetailReceivingTask(request: UpdateAdvisingDetailTaskRequest[]): Observable<any>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/updateAdvisingDetailTask`
    return this.http.put(url,request);
  }

  updateHeaderReceivingTask(request: UpdateAdvisingHeaderTaskRequest[]): Observable<any>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/updateAdvisingTask`
    return this.http.put(url,request);
  }

  getEmployeeList(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/employee/getEmployeeList`;
    return this.http.get(url);
  }

  findFilesByDocId(request: ReceivingInstructionFilesRequest): Observable<ReceivingInstructionFilesResponse>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/findAdvisingTaskFiles`;
    return this.http.post<ReceivingInstructionFilesResponse>(url, request);
  }

  updateReceivingInstructionFile(request: ReceivingInstructionFileUpdateRequest): Observable<ReceivingInstructionFileUpdateResponse> {
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/updateAdvisingTaskFiles`;
    return this.http.post<ReceivingInstructionFileUpdateResponse>(url, request);
  }

  updateReceivingTask(request: UpdateReceivingTaskRequest): Observable<any>{
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/updateReceivingTask`
    return this.http.put(url,request);
  }

  uploadBatchN035Task(file: File, selectedAdNoList: string[], taskRemark: string): Observable<HttpResponse<Blob>> {
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/uploadBatchN035Task`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('selectedAdNoListJson', JSON.stringify(selectedAdNoList));
    formData.append('taskRemark', taskRemark || '');
    return this.http.post(url, formData, { responseType: 'blob', observe: 'response' });
  }

  downloadBatchN035Template(): Observable<Blob> {
    const url = `${environment.logisticsApiUrl}/advising/receivingInstruction/downloadBatchN035Template`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
